import CurrentLocation from "./components/CurrentLocation";
import AddressForm from "./components/AddressForm";
import GoogleMapPicker from "./components/GoogleMapPicker";


import "./AddressStep.css";

function AddressStep({

    providerData,

    setProviderData,

    nextStep,

    previousStep,

}) {

    const validate = () => {

        const address = providerData.address || {};

        if (!address.doorNo) {

            alert("Door Number is required.");

            return false;

        }

        if (!address.street) {

            alert("Street is required.");

            return false;

        }

        if (!address.area) {

            alert("Area is required.");

            return false;

        }

        if (!address.city) {

            alert("City is required.");

            return false;

        }

        if (!address.state) {

            alert("State is required.");

            return false;

        }

        if (!address.pincode) {

            alert("Pincode is required.");

            return false;

        }

       

        return true;

    };

    const handleContinue = () => {

        if (!validate()) return;

        nextStep();

    };

    return (

        <div className="address-step">

            <h1>

                Business Address

            </h1>

            <p>

                Help customers find your business location.

            </p>

            <CurrentLocation

                providerData={providerData}

                setProviderData={setProviderData}

            />

            <AddressForm

                providerData={providerData}

                setProviderData={setProviderData}

            />

            <GoogleMapPicker

                providerData={providerData}

            />

            
            <div className="button-row">

                <button

                    className="back-btn"

                    onClick={previousStep}

                >

                    ← Back

                </button>

                <button

                    className="next-btn"

                    onClick={handleContinue}

                >

                    Continue →

                </button>

            </div>

        </div>

    );

}

export default AddressStep;